import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postTasks, putRoadmap } from "../services/tasks/tasks";

export default function CreateModal(props) {
    // let { showModal, setShowModal, handleSubmit, title, setTitle, saveTasks,
    //     setTastText, setDescription, description, taskText } = props;
    let { showModal, setShowModal, selectedProject } = props;

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    // const [showModal, setShowModal] = useState(false);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [taskText, setTastText] = useState("private");
    const [userId, setUserId] = useState(null);
    // const [data, setData] = useState([DEFAULT_NOTIFICATION]);
    const [state, setState] = useState(false);
    const [tasks, setTasks] = useState([]);
    const notify = () => toast.success("Task Added");
    const navigate = useNavigate();

    useEffect(() => {
        // getAllTasks();
        // let userId = JSON.parse(localStorage.getItem("userId"));
        // console.log("userId", userId);
        // setUserId(userId);
        console.log("selectedProject._id", selectedProject)
        let userId = localStorage.getItem("userId");
        setUserId(userId);
        console.log("userId", userId);
        if (selectedProject) {
            setTitle(selectedProject.title);
            setDescription(selectedProject.description);
        }
    }, [selectedProject]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setTitle("");
        setDescription("");
        setTastText("");
    };

    const updateRoadMap = () => {
        selectedProject.title = title;
        selectedProject.description = description;
        putRoadmap(selectedProject._id, selectedProject).then(res => {
            setShowModal(false);
        }).catch(e => {
            console.error(e)
        })
    };

    const saveTasks = () => {
        if (!userId) {
            toast.warn("You must login to create a Project");
            return;
        }
        if (!title || !description) {
            toast.warn("You must type title and description to create a Project");
            return
        }
        let payload = {
            tasks: tasks,
            title: title,
            description: description,
            type: taskText,
            userId: userId,
        };
        postTasks(payload)
            .then((res) => {
                setState(true);
                console.log("res: ", res);
                setShowModal(false);
                console.log("id", res.id);
                navigate(`/roadmap/${res.id}`);
                setTitle("");
                setDescription("");
                setTastText("");
                notify();
            })
            .catch((e) => {
                console.error(e);
            });
    };


    return (
        <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            style={{ width: "100%" }}
        >
            <Modal.Header closeButton>
                <Modal.Title className="text-dark">Create Roadmap</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput1"
                    >
                        <Form.Label className="text-dark">Title</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Title"
                            autoFocus
                            onChange={(e) => {
                                setTitle(e.target.value);
                            }}
                            value={title}
                        />
                    </Form.Group>
                    <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlTextarea1"
                    >
                        <Form.Label className="text-dark">Description</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Description"
                            onChange={(e) => {
                                setDescription(e.target.value);
                            }}
                            value={description}
                        />
                    </Form.Group>
                    <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlSelect1"
                    >
                        <Form.Label className="text-dark">Select Type</Form.Label>
                        <Form.Control
                            as="select"
                            onChange={(e) => {
                                setTastText(e.target.value);
                            }}
                            value={taskText}
                        >
                            <option value="public" selected>Public</option>
                            <option value="private">Private</option>
                        </Form.Control>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                    Close
                </Button>
                <Button
                    variant="primary"
                    onClick={() => {
                        saveTasks();
                        // if (selectedProject) {
                        //     updateRoadMap();
                        // } else {
                        //     saveTasks();
                        // }
                    }}
                >
                    {selectedProject ? "Update" : "Create"}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
